import { GDTApiErrors } from '@/types';
import {
  ResponseAnswerTrivia,
  ResponseDashBoard,
  ResponseVotarEncuesta,
} from '@/types/dashboard';
import axiosGdt from '@/utils/axiosGdt';
import { axiosErrorHandler } from '@/utils/functions';
import { URLs } from '@/utils/urls';

/**
 * dashboard - rankings
 */
export const getDashboardRankings = axiosErrorHandler(async () => {
  const url = URLs.DASHBOARD.RANKINGS;
  const response = await axiosGdt.get<ResponseDashBoard>(url);
  return response.data;
});

export const voteSurvey = axiosErrorHandler(async (id: number) => {
  const data = new URLSearchParams();
  data.append('idOpcionEncuestaSeleccionada', id + '');
  const url = URLs.DASHBOARD.SURVEY;
  const response = await axiosGdt.post<ResponseVotarEncuesta | GDTApiErrors>(
    url,
    data,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return response.data;
});

export const initDashboardTrivia = axiosErrorHandler(async () => {
  const url = URLs.DASHBOARD.INICIAR_TRIVIA;
  const response = await axiosGdt.get(url);
  return response.data;
});

export const participateTrivia = axiosErrorHandler(async () => {
  const url = URLs.DASHBOARD.PARTICIPAR_TRIVIA;
  const response = await axiosGdt.post(url);
  return response.data;
});

export const getTriviaQuestions = axiosErrorHandler(async () => {
  const url = URLs.DASHBOARD.OBTENER_PREGUNTA;
  const response = await axiosGdt.post(url);
  return response.data;
});

interface Params {
  nroDePreguntaActual: number;
  idPregTrivia: number;
  idRespuesta: number;
}

export const answerQuestion = axiosErrorHandler(async (params: Params) => {
  const url = URLs.DASHBOARD.RESPONDER_PREGUNTA;
  const queryString = new URLSearchParams({
    nroDePreguntaActual: params.nroDePreguntaActual.toString(),
    idPregTrivia: params.idPregTrivia.toString(),
    idRespuesta: params.idRespuesta.toString(),
  }).toString();

  const urlWithParams = `${url}?${queryString}`;
  const response = await axiosGdt.post<ResponseAnswerTrivia>(urlWithParams);
  return response.data;
});
